import {
  THEME_STORAGE_KEY,
  applyThemeToDocument,
  migrateThemeStorage,
  normalizeTheme,
  DEFAULT_THEME,
} from '~/utils/theme-document'

/**
 * SSR：通过 cookie 输出 `html.dark`，与默认深色一致。
 * 客户端：hydration 完成后再读 localStorage，避免与 SSR class 不一致导致 mismatch。
 */
export default defineNuxtPlugin((nuxtApp) => {
  const theme = useCookie(THEME_STORAGE_KEY, {
    default: () => DEFAULT_THEME,
    watch: true,
  })

  useHead({
    htmlAttrs: {
      class: computed(() => (theme.value === 'dark' ? 'dark' : '')),
    },
  })

  if (!import.meta.client) return

  const syncThemeToDomAndStorage = (value: string) => {
    const mode = normalizeTheme(value, DEFAULT_THEME)
    if (mode !== value) {
      theme.value = mode
      return
    }
    applyThemeToDocument(mode === 'dark')
    localStorage.setItem(THEME_STORAGE_KEY, mode)
  }

  nuxtApp.hook('app:mounted', () => {
    migrateThemeStorage(THEME_STORAGE_KEY)

    const fromStorage = localStorage.getItem(THEME_STORAGE_KEY)
    if (fromStorage === 'light' || fromStorage === 'dark') {
      theme.value = fromStorage
    }

    syncThemeToDomAndStorage(theme.value)

    watch(theme, syncThemeToDomAndStorage)
  })
})
